import React, { useMemo } from "react";
import useTableElements from "data-lake/hooks/useTableElements";
import { DEFAULT_LAYOUT, ADDITIONAL_ATTRIBUTES } from "data-lake/data-lake-overview/Constants";
import { keyFn, fetchDataLakes } from "data-lake/hooks/useDataLakes";
import { PaginatedEntityTable } from "components/common";
import SelectedInternalDataLakeProvider from "data-lake/contexts/SelectedInternalDataLakeProvider";
import CustomColumnRenderers from "./ColumnRenderers";
const DataLakeOverview = () => {
  const { entityActions } = useTableElements();
  const columnRenderers = useMemo(() => CustomColumnRenderers(), []);
  return /* @__PURE__ */ React.createElement(SelectedInternalDataLakeProvider, null, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "data lakes",
      additionalAttributes: ADDITIONAL_ATTRIBUTES,
      entityActions,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchDataLakes,
      keyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers
    }
  ));
};
export default DataLakeOverview;
